import { AppConfig } from '@ltvco/refresh-lib/ctx';
import { useQuery } from '@ltvco/refresh-lib/vendors';
import { useContext } from 'react';

import { vehicleRecalls } from '../api';

import { VEHICLE_RECALLS_QUERY_KEY_PREFIX } from './constants';

import type {
  VehicleRecallsParams,
  VehicleRecallsResponse,
} from '../interfaces';

export function hasValidVehicleParams(
  params: VehicleRecallsParams | null
): boolean {
  if (!params) {
    return false;
  }
  if (params.vin?.trim()) {
    return true;
  }
  if (params.license_plate?.trim() && params.state?.trim()) {
    return true;
  }
  if (params.make?.trim() && params.model?.trim() && params.year?.trim()) {
    return true;
  }
  return false;
}

export const useVehicleRecalls = (
  params: VehicleRecallsParams | null,
  options?: { enabled?: boolean }
) => {
  const { logError } = useContext(AppConfig);
  const hasValidVehicleParamsResult = hasValidVehicleParams(params);
  const enabled = options?.enabled !== false && hasValidVehicleParamsResult;

  return useQuery<VehicleRecallsResponse>(
    [VEHICLE_RECALLS_QUERY_KEY_PREFIX, params],
    () => {
      return vehicleRecalls.fetchRecalls(params!);
    },
    {
      enabled,
      refetchOnWindowFocus: false,
      onError: (error: unknown) => {
        logError(`${VEHICLE_RECALLS_QUERY_KEY_PREFIX} failed`, error as Error);
      },
    }
  );
};
